import { useActorMember, useAxios, useSubjectMember } from '@healthblocks-io/core'
import { useCallback } from 'react'
import { v4 as uuidv4 } from 'uuid'

import { useAxiosAsync } from '@/@bothrs-react/hooks/useAxiosAsync'

import type { PatientCommunicationMessage } from '@/modules/care-question/types/patient-communication.type'
import type { PatientCommunication } from '../types/message.types'

export const useReplyToPatientCommunication = () => {
  const member = useSubjectMember()
  const actorMember = useActorMember()

  const axios = useAxios()

  const replyToPatientCommunication = useCallback(
    (communication: PatientCommunication, message: string) => {
      const latestNonPatientMessage = communication?.messages.find((message) => message.sender.type !== 'patient')
      const receiver = latestNonPatientMessage?.sender || communication?.messages[0].receiver

      const now = new Date().toISOString()
      const newMessage: PatientCommunicationMessage = {
        id: uuidv4(),
        sender: {
          name: `${member?.givenName} ${member?.familyName}`,
          type: 'patient',
          actorId: actorMember?.id ?? 0,
          id: member?.id,
        },
        receiver: receiver || {
          name: '',
          type: 'doctor',
        },
        content: message,
        createdAt: now,
        hidden: false,
        readStatus: { patient: now },
      }

      return axios.post<PatientCommunication>(
        `/communication/${communication.id.replace('patientcommunication_', '')}/messages`,
        newMessage,
      )
    },
    [axios, member?.familyName, member?.givenName, actorMember?.id, member?.id],
  )

  return {
    replyToPatientCommunication: useAxiosAsync(replyToPatientCommunication),
  }
}
